import Login from './Login'
import { connect, selectors, actions } from '../../../stores'

const mapStateToProps = state => ({
  hasInviteLink: selectors.auth.selectHasInviteLink(state),
  username: selectors.auth.selectCurrentUserUsername(state),
  error: selectors.auth.selectLoginError(state),
});
  
const mapDispatchToProps = dispatch => ({
  acceptInvite: payload => dispatch(actions.auth.acceptInvite(payload)),
  signIn: payload => dispatch(actions.auth.signIn(payload)),
  setUrlParams: payload => dispatch(actions.auth.setUrlParams(payload)),
  setCurrentUser: payload => dispatch(actions.auth.setCurrentUser(payload))
});

const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);

export default ConnectedLogin